import Vue from 'vue'
import Vuex from 'vuex'

import auth from './modules/auth'
import alert from './modules/alert'
import profile from './modules/profile'
import snack_bar from './modules/snack_bar'
import {SettingsService} from '../services/storage.service'

Vue.use(Vuex)

// const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
    state: {
        internetConnection: false,
    },
    getters: {
        hasInternetConnection(state) {
            return state.internetConnection
        },
    },
    actions: {},

    mutations: {
        internet(state, hasInternetConnection) {
            state.internetConnection = hasInternetConnection
        }
    },
    modules: {
        auth,
        alert,
        profile,
        snack_bar,
    },
    // strict: debug,
    // plugins: debug ? [createLogger()] : []
})
